import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f03765ea&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f03765ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03765ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f03765ea')) {
      api.createRecord('f03765ea', component.options)
    } else {
      api.reload('f03765ea', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f03765ea&scoped=true&", function () {
      api.rerender('f03765ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dNFJDYnVtZHr/JS/comp/GuestBox.vue"
export default component.exports